import styled from 'styled-components';

import { GenericSpan, FlexDiv, GenericP } from 'commonStyles';

export const Copy = styled(GenericP)`
	color: ${(props) => props.color ? props.color : '#374B63'};
	border-left: 1px solid #ffffff;
`;

export const CurlContent = styled(FlexDiv)`
	background-color: ${(props) => props.color ? props.color : '#505669'};
	max-height: 440px;
	overflow-x: scroll;
`;

export const CurlWrapper = styled.pre`
	border: none;
	background-color: inherit;
	font-size: 14px;
	line-height: 2.3;
	font-family: 'lato',Arial,Helvetica,sans-serif;
	color: ${(props) => props.defaultColor ? props.defaultColor : '#FFF'};
	margin-bottom: 10px !important;
	.value { 
		color: ${(props) => props.colorValue || props.defaultColor || '#399B37'}; 
	}
	.key {
		 color: ${(props) => props.colorKey || props.defaultColor || '#374B63'} ;
	}
`;

export const CurlList = styled.li`
	margin-bottom: 18px;
	margin-left: 10px;
`;

export const CurlLine = styled(GenericSpan)`
	line-height : 20px
`;
